import { AppRouteProps } from "@bsm/component";
import React from "react";
import { UserStudentFamilyDetailsContainer } from "./container/UserStudentFamilyDetailsContainer";
import { UserStudentFamilyCreateContainer } from "../create/container/UserStudentFamilyCreateContainer";


export const UserStudentFamilyDetailsRoute = [
    {
        path: ":familyId",
        element: <UserStudentFamilyDetailsContainer />,
        children: [
            {
                path: "edit",
                element: <UserStudentFamilyCreateContainer />
            },
        ]
    },
] as Array<AppRouteProps>